import { GET_AP_SNAPSHOT, GET_AP_SNAPSHOT_FAIL, GET_AP_SNAPSHOT_SUCCESS } from '../../constants/accessPointConstants';

/**
 * Reducer function for managing audit log list.
 *
 * @param {object} state - Current state of the audit log list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */

export const snapshotHistoryListReducer = (state = { snapshotHistoryList: {} }, action) => {
    switch (action.type) {
        case GET_AP_SNAPSHOT:
            return {
                ...state,
                loading: true,
            };
        case GET_AP_SNAPSHOT_SUCCESS:
            return {
                ...state,
                loading: false,
                snapshotHistoryList: action.payload,
            };
        case GET_AP_SNAPSHOT_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};
